"use client";

import { Box, Trophy, Globe, Shield, BadgeCheck, Server } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { whyChooseUs as data } from "@/lib/data/platform-capabilities";

const reasonIcons = [Box, Trophy, Globe, Shield, BadgeCheck, Server] as const;
const accents = [
  "var(--color-crimson)",
  "var(--color-amber)",
  "var(--color-cyan)",
  "var(--color-emerald)",
  "var(--color-purple)",
  "var(--color-denim)",
] as const;

export function WhyChooseUs() {
  return (
    <Section id="why-choose-us" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-amber)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
          </div>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {data.reasons.map((r, i) => {
            const Icon = reasonIcons[i % reasonIcons.length]!;
            const accent = accents[i % accents.length]!;
            return (
              <Reveal key={r.title} delay={i * 60}>
                <div
                  className="glass rounded-2xl p-6 h-full"
                  style={{
                    boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 12%, transparent)`,
                  }}
                >
                  <span
                    className="grid place-items-center h-11 w-11 rounded-xl"
                    style={{
                      background: `color-mix(in oklch, ${accent} 18%, transparent)`,
                      boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)`,
                    }}
                  >
                    <Icon className="h-5 w-5" style={{ color: accent }} />
                  </span>
                  <h3 className="mt-4 text-lg">{r.title}</h3>
                  <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{r.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </Section>
  );
}
